import React from "react";

// External package
import Carousel from "react-multi-carousel";

// source
import { projectTools } from "../../source/serviceFeaturesSource";
export default function describeMeComponents() {
  const responsiveTools = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 5,
    },
  };

  return (
    <div className="describe_me">
      <p className="first-letter-capital font-vietnam-300">
        As a Front-end web developer, I bring a passion for coding and a
        commitment to delivering high-quality, responsive websites to my
        clients. With extensive experience in HTML, CSS, and JavaScript /
        TypeScript, I am skilled in creating visually appealing and
        user-friendly interfaces that meet the needs of businesses and
        organizations of all sizes.
      </p>
      <p className="font-vietnam-300">
        I have a strong understanding of user experience design principles and
        use this knowledge to create engaging websites that are easy to navigate
        and optimized for search engines. I am also adept at using a range of
        Front-end development tools and frameworks such as React and Vue.js,
        which allows me to create powerful and dynamic web applications.
      </p>
      <p className="font-vietnam-300">
        My ability to work collaboratively with clients and colleagues to
        understand their needs and deliver tailored solutions is a hallmark of
        my work. Whether working on large-scale projects or individual
        assignments, I pride myself on my attention to detail, my ability to
        meet tight deadlines, and my commitment to producing clean, maintainable
        code.
      </p>
      <div className="tools-project">
        <label htmlFor="" className="font-size-36 font-vietnam-600">
          Tools
        </label>
        <div className="tools-project_images">
          <Carousel
            responsive={responsiveTools}
            autoPlaySpeed={2000}
            autoPlay={true}
            infinite={true}
            ssr={true}
            arrows={false}
          >
            {projectTools.map((tool) => (
              <div
                key={tool.id}
                data-aos="zoom-in"
                data-aos-anchor-placement="top-center"
                data-aos-duration={"1" + tool.id * 1000}
              >
                <img src={tool.image} alt={tool.title} loading="lazy" />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}
